import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex justify-content-between align-items-center w-full mb-5" }
const _hoisted_2 = { class: "font-semibold text-xl" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-column"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_settings" }, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "flex flex-column pt-2 h-full"
}
const _hoisted_6 = { class: "font-semibold" }
const _hoisted_7 = { class: "gauge mb-0" }
const _hoisted_8 = { class: "particles" }
const _hoisted_9 = { class: "p-0 mb-0" }
const _hoisted_10 = {
  key: 0,
  class: "flex align-items-center gap-2"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "w-12rem" }, "PM 10", -1)
const _hoisted_12 = { class: "w-22rem text-right" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("sup", null, "3", -1)
const _hoisted_14 = {
  key: 1,
  class: "flex align-items-center gap-2"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "w-12rem" }, "PM 2.5", -1)
const _hoisted_16 = { class: "w-22rem text-right" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("sup", null, "3", -1)
const _hoisted_18 = {
  key: 2,
  class: "flex align-items-center gap-2"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "w-12rem" }, [
  /*#__PURE__*/_createTextVNode("SO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2")
], -1)
const _hoisted_20 = { class: "w-22rem text-right" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("sup", null, "3", -1)
const _hoisted_22 = {
  key: 3,
  class: "flex align-items-center gap-2"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "w-12rem" }, [
  /*#__PURE__*/_createTextVNode("NO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2")
], -1)
const _hoisted_24 = { class: "w-22rem text-right" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("sup", null, "3", -1)
const _hoisted_26 = {
  key: 4,
  class: "flex align-items-center gap-2"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "w-12rem" }, [
  /*#__PURE__*/_createTextVNode("O"),
  /*#__PURE__*/_createElementVNode("sub", null, "3")
], -1)
const _hoisted_28 = { class: "w-22rem text-right" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("sup", null, "3", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdvancedGaugeChartHome = _resolveComponent("AdvancedGaugeChartHome")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!

  return (_openBlock(), _createElementBlock("div", {
    tabindex: "1",
    class: "flex flex-column bg-white border-round-3xl border-1 border-300 p-4 w-20rem sm:w-25rem h-28rem cursor-pointer",
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'AirQuality', params: { id: _ctx.externalId } }))),
    onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (
      _ctx.$router.push({ name: 'AirQuality', params: { id: _ctx.externalId } })
    ), ["enter"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("widgets.air-quality.title")), 1),
      (_ctx.user)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: "icon-warpit_icon_settings text-2xl",
            tabindex: "1",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('edit')), ["stop"])),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.$emit('edit')), ["stop"]), ["enter"]))
          }, null, 32))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.externalId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("widgets.not_configured")), 1),
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(_ctx.$t("widgets.configure")) + " ", 1),
            _hoisted_4,
            _createTextVNode(".")
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.payload.name), 1),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_AdvancedGaugeChartHome, {
              percentage: parseInt(_ctx.payload.measurements.index) || 0,
              min: 0,
              max: 300,
              bands: [
            {
              from: 0,
              to: 50,
              color: _ctx.aqRangeColors.blue,
              thickness: '45%',
            },
            {
              from: 51,
              to: 100,
              color: _ctx.aqRangeColors.green,
              thickness: '45%',
            },
            {
              from: 101,
              to: 150,
              color: _ctx.aqRangeColors.yellow,
              thickness: '45%',
            },
            {
              from: 151,
              to: 200,
              color: _ctx.aqRangeColors.orange,
              thickness: '45%',
            },
            {
              from: 201,
              to: 250,
              color: _ctx.aqRangeColors.red,
              thickness: '45%',
            },
            {
              from: 251,
              to: 300,
              color: _ctx.aqRangeColors.purple,
              thickness: '45%',
            },
          ]
            }, null, 8, ["percentage", "bands"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("ul", _hoisted_9, [
              (_ctx.payload.measurements.PM10 !== null)
                ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", {
                      class: _normalizeClass(["progressBar", 
                _ctx.getValueColorClass('pm10', Number(_ctx.payload.measurements.PM10))
              ])
                    }, [
                      _createVNode(_component_ProgressBar, {
                        value: 
                  (Number(_ctx.payload.measurements.PM10) / _ctx.aqRanges.pm10[5]) * 100
                
                      }, null, 8, ["value"])
                    ], 2),
                    _createElementVNode("span", _hoisted_12, [
                      _createTextVNode(_toDisplayString(parseFloat(_ctx.payload.measurements.PM10).toFixed(2)) + " μg/m ", 1),
                      _hoisted_13
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.payload.measurements.PM2_5 !== null)
                ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("div", {
                      class: _normalizeClass(["progressBar", 
                _ctx.getValueColorClass('pm2_5', Number(_ctx.payload.measurements.PM2_5))
              ])
                    }, [
                      _createVNode(_component_ProgressBar, {
                        value: 
                  (Number(_ctx.payload.measurements.PM2_5) / _ctx.aqRanges.pm2_5[5]) * 100
                
                      }, null, 8, ["value"])
                    ], 2),
                    _createElementVNode("span", _hoisted_16, [
                      _createTextVNode(_toDisplayString(parseFloat(_ctx.payload.measurements.PM2_5).toFixed(2)) + " μg/m ", 1),
                      _hoisted_17
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.payload.measurements.SO2 !== null)
                ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("div", {
                      class: _normalizeClass(["progressBar", 
                _ctx.getValueColorClass(
                  'so2',
                  Number(_ctx.payload.measurements.SO2) / 0.000355,
                )
              ])
                    }, [
                      _createVNode(_component_ProgressBar, {
                        value: 
                  (Number(_ctx.payload.measurements.SO2) /
                    0.000355 /
                    _ctx.aqRanges.so2[5]) *
                  100
                
                      }, null, 8, ["value"])
                    ], 2),
                    _createElementVNode("span", _hoisted_20, [
                      _createTextVNode(_toDisplayString(parseFloat(_ctx.payload.measurements.SO2 / 0.000355).toFixed(2)) + " μg/m ", 1),
                      _hoisted_21
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.payload.measurements.NO2 !== null)
                ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("div", {
                      class: _normalizeClass(["progressBar", 
                _ctx.getValueColorClass(
                  'no2',
                  Number(_ctx.payload.measurements.SO2) / 0.000494,
                )
              ])
                    }, [
                      _createVNode(_component_ProgressBar, {
                        value: 
                  (Number(_ctx.payload.measurements.NO2) /
                    0.000494 /
                    _ctx.aqRanges.no2[5]) *
                  100
                
                      }, null, 8, ["value"])
                    ], 2),
                    _createElementVNode("span", _hoisted_24, [
                      _createTextVNode(_toDisplayString(parseFloat(_ctx.payload.measurements.NO2 / 0.000494).toFixed(2)) + " μg/m ", 1),
                      _hoisted_25
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.payload.measurements.O3 !== null)
                ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("div", {
                      class: _normalizeClass(["progressBar", 
                _ctx.getValueColorClass(
                  'no2',
                  Number(_ctx.payload.measurements.O3) / 0.000473,
                )
              ])
                    }, [
                      _createVNode(_component_ProgressBar, {
                        value: 
                  (Number(_ctx.payload.measurements.O3) /
                    0.000473 /
                    _ctx.aqRanges.o3[5]) *
                  100
                
                      }, null, 8, ["value"])
                    ], 2),
                    _createElementVNode("span", _hoisted_28, [
                      _createTextVNode(_toDisplayString(parseFloat(_ctx.payload.measurements.O3 / 0.000473).toFixed(2)) + " μg/m ", 1),
                      _hoisted_29
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
  ], 32))
}